import React from 'react';
import { Award } from 'lucide-react';
import { useTranslation } from '../translations';

const SealBadge = ({ sealType, size = 'md', showText = true, showEmoji = true, evaluationCount }) => {
  const { t } = useTranslation();
  
  const sealConfig = {
    gold: {
      color: 'bg-yellow-500',
      textColor: 'text-yellow-900',
      borderColor: 'border-yellow-600',
      shadowColor: 'shadow-yellow-200',
      label: t('sealExpert'),
      emoji: '\u{1F947}'
    },
    silver: {
      color: 'bg-gray-300',
      textColor: 'text-gray-900',
      borderColor: 'border-gray-400',
      shadowColor: 'shadow-gray-200',
      label: t('sealProfessional'),
      emoji: '\u{1F948}'
    },
    bronze: {
      color: 'bg-orange-600',
      textColor: 'text-orange-100',
      borderColor: 'border-orange-700',
      shadowColor: 'shadow-orange-200',
      label: t('sealCertified'),
      emoji: '\u{1F949}'
    },
    none: {
      color: 'bg-gray-400',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-500',
      shadowColor: 'shadow-gray-200',
      label: t('sealInDevelopment'),
      emoji: '\u{1F464}'
    }
  };

  const config = sealConfig[sealType] || sealConfig.none;
  
  const sizeClasses = {
    sm: 'w-12 h-12 text-2xl',
    md: 'w-20 h-20 text-4xl',
    lg: 'w-32 h-32 text-6xl'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <div className="flex flex-col items-center gap-2" data-testid="seal-badge">
      <div className="relative">
        <div 
          className={`
            ${config.color} 
            ${config.borderColor} 
            ${config.shadowColor}
            ${sizeClasses[size]}
            rounded-full 
            border-4 
            flex 
            items-center 
            justify-center 
            shadow-lg
            transition-transform
            hover:scale-110
          `}
        >
          {showEmoji && <span className="select-none">{config.emoji}</span>}
        </div>
        {/* Evaluation count badge */}
        {evaluationCount > 0 && size !== 'sm' && (
          <div 
            className="absolute -bottom-1 -right-1 bg-blue-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center border-2 border-white shadow"
            data-testid="eval-count-badge"
            title={`${evaluationCount} ${evaluationCount === 1 ? 'avaliacao' : 'avaliacoes'}`}
          >
            {evaluationCount}
          </div>
        )}
      </div>
      {showText && (
        <span className={`font-semibold ${config.textColor} ${textSizeClasses[size]} text-center`}>
          {config.label}
        </span>
      )}
    </div>
  );
};

export default SealBadge;
